import { useState } from 'react'
import { CouponsWizard } from './CouponsWizard'
import { EventOptionCard } from '../EventOptionCard'
import cardCoupons from '../../assets/event-options/card-coupons.svg'

interface CouponsButtonProps {
  eventId: string | undefined
}

export const CouponsButton = ({ eventId }: CouponsButtonProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  if (!eventId) return null

  return (
    <>
      <EventOptionCard
        title="Cupons de desconto"
        description="Crie cupons e descontos por ingresso"
        iconSrc={cardCoupons}
        onClick={() => setIsOpen(true)}
      />

      {isOpen && (
        <CouponsWizard eventId={eventId} onClose={() => setIsOpen(false)} />
      )}
    </>
  )
}

export default CouponsButton
